import * as ko from 'knockout'
import { Params, TrotFinisherViewModel } from './TrotFinisherViewModel'
import template from './trot.finisher.tpl.html'

if (!ko.components.isRegistered('trot-finisher')) {
  ko.components.register('trot-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new TrotFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
